








import { Component, Prop, Vue } from 'vue-property-decorator'
import { getVendorTypes } from '@/api/vendors'
import { VendorTypeModule } from '@/store/modules/vendorTypes'

@Component({
  name: 'VendorTypeOption'
})
export default class extends Vue {
  @Prop({ required: true }) private value!: number

  mounted() {
    this.$nextTick(() => {
      this.fetchData()
    })
  }

  get vendorType() {
    return this.value
  }

  set vendorType(updated) {
    this.$emit('input', updated)
  }

  private options = [{ key: 0, name: 'name' }]
  private async fetchData() {
    let list = VendorTypeModule.cachedVendorTypes
    if (list.length === 0) {
      console.info(`Fetching vendor types. ${list.length}`)
      const response = await getVendorTypes()
      VendorTypeModule.loadVendorTypes(response.data)
      list = VendorTypeModule.cachedVendorTypes
    }
    this.options = list.map((c) => { return { key: c.vendorTypeId, name: c.description } })
  }
}
